import axios from 'axios'

const API_PATH = 'api/v2/admins/cms/noticebars'

const CmsNoticebarApiV2 = {
  get: async () => {
    const path = API_PATH

    const response = axios.get(path, {})
    return response
  },

  /**
   * Update a Cms Noticebar
   * Invoke `PATCH api/v2/admins/cms/noticebars/:id'
   * @param {number} id Noticebar ID
   * @param {object} payload fields to change
   */
  update: async (payload) => {
    const path     = `${API_PATH}/${payload.id}`
    const body     = {
      noticebar: payload
    }
    const response = axios.patch(path, body)

    return response
  }
}

export default CmsNoticebarApiV2
